import './RestaurantsHeadingAndContentBlock.css';
import React, { memo, useState } from 'react';
import { canUseDOM, get } from '../../utils';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import { isNil } from '../../utils/IsNil';
const RestaurantsHeadingAndContentBlock = /*#__PURE__*/memo(_ref => {
  let {
    fields
  } = _ref;
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const [isVdsite, setIsVdsite] = useState(true);
  const title = get(fields, 'data.datasource.title.jss.value');
  const subTitle = get(fields, 'data.datasource.introText.jss.value');
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  if (isNil(fields) || isNil(fields.data) || isNil(fields.data.datasource) || fields.data.datasource.title.jss.value === "") {
    console.info('RestaurantsHeadingAndContentBlock component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [RestaurantsHeadingAndContentBlock component is empty: please provide data source]");
    }
    return null;
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("p", {
    className: "title"
  }, title), subTitle ? /*#__PURE__*/React.createElement("p", {
    className: "subTitle"
  }, subTitle) : null);
});
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
const commonStyles = "c1f6aye9";
const ltrStyles = "l1nw6awg";
const rtlStyles = "r1ppdrp6";
export default RestaurantsHeadingAndContentBlock;